import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllProducts = async (queryString = "") => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'products' + queryString, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getAllProductsObject = async (queryString = "") => {
    const allProducts = await getAllProducts(queryString);

    const allProductObject = allProducts.products.map((product) => {
        return {
            id : product.id ,
            value : product.id ,
            label : product.persianTitle,
        }
    })

    return allProductObject;
}
export const getProductById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `products/${id}` , {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const uploadInformationPictures = async (picture) => {
    const headers = getManagerHeader();
    return axios.post(baseCmsApiUrl + 'informationPictures', picture, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data.src;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getColors = (singleProducts) => {

    const colors = [];
    for (let i = 0; i < singleProducts.length; i++) {
        const tempColor = {
            color: singleProducts[i].color,
            hexColor: singleProducts[i].hexColor
        };

        if (singleProducts[i].color && !colors.some(c => c.color === tempColor.color)) {
            colors.push(tempColor)
        }

    }

    return colors;
};
export const getSizes = (singleProducts) => {

    const sizes = [];
    for (let i = 0; i < singleProducts.length; i++) {
        if (singleProducts[i].size && !sizes.includes(singleProducts[i].size)) {
            sizes.push(singleProducts[i].size)
        }
    }

    return sizes;
};
export const setSingleProducts = (colors = [], sizes = []) => {
    const price = {
        amount: "",
        discountAmount: "",
        discountPercent: "",
        isClosed: "",
        closedRate: "",
        minimumRate: "",
    };
    const installment = {
        minimumPrePaymentAmount: "",
        minimumPrePaymentPercent: "",
        refundMethod: "MONTHLY",
        maxNumberOfInstallment: "",
        profitAmount: "",
        profitPercent: "",
    };
    const limitation = {
        minOrderNumberForNormal: "",
        minOrderNumberForSilver: "",
        minOrderNumberForGold: "",
        maxOrderNumberForNormal: "",
        maxOrderNumberForSilver: "",
        maxOrderNumberForGold: "",
    };

    const singleProduct = {
        color: "",
        hexColor: "",
        size: "",
        balance: "",
        activePicture: "",
        customAttributeId1: "",
        valueAttributeId1: "",
        customAttributeId2: "",
        valueAttributeId2: "",
        productPrices: {
            normalPrice: {...price},
            silverPrice: {...price},
            goldPrice: {...price},
            normalInstallment: {...installment},
            silverInstallment: {...installment},
            goldInstallment: {...installment},
        },
        limitation: {...limitation}
    }

    const singleProducts = [];
    if (colors.length == 0 && sizes.length == 0)
        singleProducts.push({...singleProduct});
    else if (colors.length > 0 && sizes.length == 0) {
        for (let i = 0; i < colors.length; i++) {
            singleProducts.push({...singleProduct, color: colors[i].color, hexColor: colors[i].hexColor});
        }
    } else if (colors.length == 0 && sizes.length > 0) {
        for (let i = 0; i < sizes.length; i++) {
            singleProducts.push({...singleProduct, size: sizes[i]});
        }
    } else {
        for (let i = 0; i < colors.length; i++) {
            for (let j = 0; j < sizes.length; j++) {
                singleProducts.push({
                    ...singleProduct,
                    color: colors[i].color,
                    hexColor: colors[i].hexColor,
                    size: sizes[j]
                });
            }
        }
    }

    return singleProducts;
}
export const resetSingleProductPrices = (singleProducts) => {
    const price = {
        amount: "",
        discountAmount: "",
        discountPercent: "",
        isClosed: "",
        closedRate: "",
        minimumRate: "",
    };
    const installment = {
        minimumPrePaymentAmount: "",
        minimumPrePaymentPercent: "",
        refundMethod: "MONTHLY",
        maxNumberOfInstallment: "",
        profitAmount: "",
        profitPercent: "",
    };
    const limitation = {
        minOrderNumberForNormal: "",
        minOrderNumberForSilver: "",
        minOrderNumberForGold: "",
        maxOrderNumberForNormal: "",
        maxOrderNumberForSilver: "",
        maxOrderNumberForGold: "",
    };

    const newSingleProducts = [...singleProducts];
    for (let i = 0; i < singleProducts.length; i++) {
        newSingleProducts[i] = {
            ...newSingleProducts[i],
            productPrices: {
                normalPrice: {...price},
                silverPrice: {...price},
                goldPrice: {...price},
                normalInstallment: {...installment},
                silverInstallment: {...installment},
                goldInstallment: {...installment},
            },
            limitation: {...limitation}
        }
    }
    return newSingleProducts;
}
export const isSellable = (sellingTypeId) => {
    if (sellingTypeId == 4 || sellingTypeId == 5 || sellingTypeId == 6)
        return false;

    return true;
}
export const minmaxPrice = (singleProducts, userLevel) => {
    let min = 0;
    let max = 0;
    for (let i = 0; i < singleProducts.length; i++) {
        const {amount, discountAmount} = singleProducts[i].productPrices[`${userLevel}Price`];
        const price = discountAmount || amount;

        if (i == 0)
            min = max = price;
        else if (price > max)
            max = price;
        else if (price < min)
            min = price;

    }
    return [min, max];
}
export const minmaxRefundAmount = (product, userLevel) => {
    const pricePeriod = minmaxPrice(product.singleProducts, userLevel);
    const installment = {...product.singleProducts[0].productPrices[`${userLevel}Installment`]};
    const rate = product.currency.rate;
    let minRefundPrice = 0;
    let maxRefundPrice = 0;

    if (installment.minimumPrePaymentAmount) {
        minRefundPrice += parseInt(installment.minimumPrePaymentAmount);
        maxRefundPrice += parseInt(installment.minimumPrePaymentAmount);
    } else if (installment.minimumPrePaymentPercent) {
        minRefundPrice += parseInt(installment.minimumPrePaymentPercent) * pricePeriod[0] / 100 ;
        maxRefundPrice += parseInt(installment.minimumPrePaymentPercent) * pricePeriod[1] / 100;
    }

    if (installment.profitAmount) {
        minRefundPrice += (pricePeriod[0] - minRefundPrice) + (installment.maxNumberOfInstallment * installment.profitAmount);
        maxRefundPrice += (pricePeriod[1] - maxRefundPrice) + (installment.maxNumberOfInstallment * installment.profitAmount);
    } else if (installment.profitPercent) {
        minRefundPrice += (pricePeriod[0] - minRefundPrice) + ((pricePeriod[0] - minRefundPrice) * installment.maxNumberOfInstallment / 100 * installment.profitPercent);
        maxRefundPrice += (pricePeriod[1] - maxRefundPrice) + ((pricePeriod[1] - maxRefundPrice) * installment.maxNumberOfInstallment / 100 * installment.profitPercent);
    }


    return [minRefundPrice  * rate, maxRefundPrice * rate];

}
export const printRefundAmount = (product, userLevel) => {
    const refundAmount = minmaxRefundAmount(product, userLevel);
    if (refundAmount[0] == refundAmount[1])
        return (<span>{refundAmount[0].toLocaleString()} تومان</span>);

    return (<span>بسته به مدل از {refundAmount[0].toLocaleString()} تا {refundAmount[1].toLocaleString()} تومان</span>);
}
export const printPrice = (pricePeriod , rate = 1) => {
    if (!pricePeriod[0] && !pricePeriod[1])
        return <span className={"text-danger"}>فاقد قیمت</span>

    if (pricePeriod[0] == pricePeriod[1])
        return <span>{(pricePeriod[0]*rate).toLocaleString()}</span>

    return (<span>بسته به مدل از {(pricePeriod[0]*rate).toLocaleString()} تا {(pricePeriod[1]*rate).toLocaleString()}</span>);
}
export const printInstallmentConditions = (installment) => {
    let condition = '';
    if (!installment.maxNumberOfInstallment)
        return <span className={"text-danger"}>فاقد شرایط اقساط</span>;

    if (installment.minimumPrePaymentAmount)
        condition += installment.minimumPrePaymentAmount.toLocaleString() + " تومان پیش پرداخت، ";
    else if (installment.minimumPrePaymentPercent)
        condition += installment.minimumPrePaymentPercent + " درصد پیش پرداخت، ";

    if (installment.profitAmount)
        condition += installment.profitAmount.toLocaleString() + " تومان سود ";
    else if (installment.profitPercent)
        condition += installment.profitPercent + " درصد سود ";

    switch (installment.refundMethod) {
        case "WEEKLY":
            condition += " هفتگی ";
            break;
        case "MONTHLY":
            condition += " ماهانه ";
            break;
        case "EVERY_TWO_MONTH":
            condition += " هر دو ماه ";
            break;
        case "EVERY_THREE_MONTH":
            condition += " هر سه ماه ";
            break;
        case "EVERY_FOUR_MONTH":
            condition += " هر چهار ماه ";
            break;
        case "EVERY_SIX_MONTH":
            condition += " هر شش ماه ";
            break;
        case "YEARLY":
            condition += " سالانه ";
            break;
    }
    condition += "با حداکثر " + installment.maxNumberOfInstallment + " قسط"  ;

    return <span>{condition}</span> ;

}
export const getAllProductRequests = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'productRequests', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const isProductRequestChecked = (statuses) => {
    if (statuses[statuses.length -1 ].status == "INSERT")
        return false;
    return true;
}

export const getAllSingleProductsOfProduct = async (productId) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'singleProducts?productId=' + productId, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getAllSingleProductsOfProductObject = async (productId) => {
    const singleProducts = await getAllSingleProductsOfProduct(productId);


    const allSingleProducts = singleProducts.map((singleProduct) => {
        return {
            id : singleProduct.id ,
            value : singleProduct.id ,
            label : `${singleProduct.color ? (`رنگ: ${singleProduct.color}`) : "" } ${singleProduct.size ? (`سایز: ${singleProduct.size}`) : ""}  موجودی: ${singleProduct.balance || "ناموجود"} `
        }
    })
    return allSingleProducts;
}

export const getSingleProductsOfPrices = async (singleProductId) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'productPrices?singleProductId=' + singleProductId, {headers})
        .then((response) => {
            console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getSingleProductById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'singleProducts?id=' + id, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}